<template>
  <div id="app">
    <router-view />
    <el-dialog
      title="修改密码"
      :visible.sync="updatePwdDialogVisible"
      :close-on-click-modal="false"
      custom-class="custom_dialog"
    >
      <el-row>
        <el-col :span="22" :offset="1">
          <el-form
            :model="pwdForm"
            :rules="pwdFormRules"
            ref="pwdForm"
            label-width="110px"
            class="demo-ruleForm"
            size="mini"
            :label-position="is_xs ? 'top' : 'left'"
          >
            <el-form-item label="原密码：" prop="OldPwd">
              <el-input v-model="pwdForm.OldPwd" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="新密码：" prop="NewPwd">
              <el-input v-model="pwdForm.NewPwd" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="确认新密码：" prop="ConfirmPassword">
              <el-input
                v-model="pwdForm.ConfirmPassword"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updatePwdDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updatePwd()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    const reg = /(?!^(\d+|[a-zA-Z]+|[~!@#$%^&*?.]+)$)^[\w~!@#$%^&*?.]{6,13}$/
    var validatePwd = (rule, value, callback) => {
      if (!reg.test(value)) {
        callback(new Error('密码应是6-13位数字、字母或字符！'))
      } else {
        callback()
      }
    }
    const validateComfirmPwd = (rule, value, callback) => {
      if (!reg.test(value)) {
        callback(new Error('密码应是6-13位数字、字母或字符！'))
      } else if (this.pwdForm.NewPwd !== value) {
        callback(new Error('确认密码与新密码不一致！'))
      } else {
        callback()
      }
    }
    return {
      updatePwdDialogVisible: false,
      pwdForm: {
        OldPwd: null,
        NewPwd: null,
        ConfirmPassword: null
      },
      pwdFormRules: {
        OldPwd: [
          { required: true, message: '请输入旧密码', trigger: 'blur' },
          { min: 6, max: 13, message: '密码应是6-13位数字、字母或字符！', trigger: 'blur' }],
        NewPwd: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { validator: validatePwd, trigger: 'blur' }],
        ConfirmPassword: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          { validator: validateComfirmPwd, trigger: 'blur' }]
      }
    }
  },
  created () {
    // var head = document.getElementsByTagName('HEAD').item(0)
    // var style = document.createElement('link')
    // style.href = require('../src/assets/css/theme_light.less')
    // style.rel = 'stylesheet'
    // // style.type = 'text/css'
    // style.setAttribute('type', 'text/css')
    // head.appendChild(style)

    // 在页面加载时读取sessionStorage
    if (window.localStorage.getItem('state')) {
      var state = JSON.parse(window.localStorage.getItem('state'))
      // if (store && store.startTime != null && store.expirse < new Date()) {
      //   this.$store.commit('REMOVE_ACCOUNT', store)
      // } else {
      //   this.$store.replaceState(Object.assign({}, this.$store.state, store))
      // }
      if (state && state.token != null && state.issued != null && state.expires_in != null) {
        const date = new Date().getTime()
        if (date - new Date(state.issued).getTime() < state.expires_in * 1000) {
          this.$store.replaceState(Object.assign({}, this.$store.state, state))
        }
      }
    }
    console.log('职称评定、项目评优、代表选举、评选先进')
    console.log('%c欢迎使用企业会议投票系统！', 'color:red')
  },
  methods: {
    updatePwd: function () {
      const _this = this
      const loading = _this.$loading({
        lock: true,
        text: '保存中……',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      _this.$refs.pwdForm.validate((valid) => {
        if (valid) {
          _this.$api.account.updatePwd(_this.pwdForm).then(data => {
            loading.close()
            _this.$message({
              showClose: true,
              type: 'success',
              message: '修改密码成功！'
            })
            _this.updatePwdDialogVisible = false
          }).catch(err => {
            loading.close()
            _this.updatePwdDialogVisible = false
            return err
          })
        } else {
          loading.close()
          return false
        }
      })
    }
  },
  mounted () {
    const _this = this
    this.$root.$on('openUpdatePwd', function () {
      _this.updatePwdDialogVisible = true
    })
  }
}
</script>

<style lang="less">
//
</style>
